import { http } from '../helpers/axiosHelper';

export default class TenantJourneyService {
   async postTenantJourney(tenantId: Number, journeyId: Number) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/tenant-journey', { tenant_id: tenantId, journey_id: journeyId })
         .then((response) => {
            return response.data;
         });
   }

   async deleteTenantJourney(tenantJourneyId: Number) {
      return await http.delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/tenant-journey/' + tenantJourneyId).then((response) => {
         return response.data;
      });
   }
}
